import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { px2rem } from '@/theme';

import { ReactComponent as ErrorIcon } from '@/assets/CustomError.svg';
import { ReactComponent as CloseSvg } from '@/assets/icons/close-icon.svg';

export const Wrapper = styled(Box)<{ type: string }>`
  position: relative;
  border-radius: 5px;

  ${({ theme, type }) => css`
    ${type === 'danger' &&
    css`
      border: 1px solid ${theme.colors.accentAdd6};
      color: ${theme.colors.darkError};
    `}
    padding: 1.2rem;
    background-color: ${type === 'danger'
      ? '#fff4f7'
      : theme.colors.primaryLightAdd2};
    text-align: center;

    p {
      margin-bottom: ${theme.spacing(1)};

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  `}
`;

export const Badge = styled(ErrorIcon)`
  flex-shrink: 0;
  ${({ theme }) => css`
    width: ${px2rem(16)};
    margin-right: ${theme.spacing(1)};
    display: inline-block;
  `}

  &:hover {
    cursor: pointer;
  }
`;

export const CustomWrapper = styled(Box)`
  display: flex;
  padding: 0.75rem;
  align-items: flex-start;
  align-self: stretch;

  ${({ theme }) => css`
    border: 1px solid ${theme.colors.accentAdd6};
    color: ${theme.colors.darkError};
    background: ${theme.colors.feedbackErrorAlpha20};
    color: ${theme.colors.error};
    p {
      margin-bottom: ${theme.spacing(1)};

      &:last-child {
        margin-bottom: 0;
      }
    }
  `}
`;

export const IncompleteRegistrationNotice = styled(Box)`
  text-align: left;
  ${({ theme }) => css`
    ol,
    ul {
      list-style: unset;
      padding: ${theme.spacing(0, 2)};
      margin: ${theme.spacing(2, 0)};
    }
  `}
`;

export const CloseButton = styled.button`
  position: absolute;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  ${({ theme }) => css`
    top: ${theme.spacing(0.5)};
    right: ${theme.spacing(0.5)};
    height: ${theme.spacing(2)};
    width: ${theme.spacing(2)};
    border-radius: 50%;
  `}
`;

export const CloseIcon = styled(CloseSvg)`
  width: 100%;
  height: 100%;
`;
